//import { create } from "domain";

export interface createCATConvenios{
    pagado: boolean,
    monto: number,
    descuento: number,
    tipoConvenio: number,
    participantes: number, 
    catEdicionesId: number,
    sgtEntidadIdEntidad: string,
    codigoInstitucional: string,
    documentoContable: string,
    sgtDependencia: string,
    descripcion: string,
    fechaInicio: string,
    fechaFinal: string,
    pagoExoneracion: number,
    solicitudId: number,
}

export class createCATConvenios implements createCATConvenios{
    constructor(init?:createCATConveniosFormValues){
        Object.assign(this,init);
    }
}

export class createCATConveniosFormValues{
    pagado: boolean = false
    monto: number = 0
    descuento: number = 0
    tipoConvenio: number = 0
    participantes: number = 0
    catEdicionesId: number = 0
    pagoExoneracion: number = 0
    sgtEntidadIdEntidad: string =""
    codigoInstitucional: string =""
    documentoContable: string =""
    sgtDependencia: string =""
    descripcion: string =""
    fechaInicio: string =""
    fechaFinal: string =""
    solicitudId: number = 0

    constructor(createCATConvenios?:createCATConveniosFormValues){
        if(createCATConvenios){
            this.pagado=createCATConvenios.pagado
            this.monto=createCATConvenios.monto
            this.descuento=createCATConvenios.descuento
            this.tipoConvenio=createCATConvenios.tipoConvenio
            this.participantes=createCATConvenios.participantes
            this.catEdicionesId=createCATConvenios.catEdicionesId
            this.sgtEntidadIdEntidad=createCATConvenios.sgtEntidadIdEntidad
            this.codigoInstitucional=createCATConvenios.codigoInstitucional
            this.documentoContable=createCATConvenios.documentoContable
            this.sgtDependencia=createCATConvenios.sgtDependencia
            this.descripcion=createCATConvenios.descripcion
            this.fechaInicio=createCATConvenios.fechaInicio
            this.fechaFinal=createCATConvenios.fechaFinal
            this.pagoExoneracion=createCATConvenios.pagoExoneracion
            this.solicitudId=createCATConvenios.solicitudId
            this.solicitudId= createCATConvenios.solicitudId
        }
    }
}

export interface BuscarEntidad{
    idEntidad: string,
    entidad: string,
}